(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-access-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-access-code')) {
    customElements.define('sr-access-code', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const fallback = this.querySelector('[name="password"]');
        const cells = [...this.querySelectorAll('.sr-code-cell')];
        const form = this.closest('form');
        if (!fallback || cells.length !== 6 || !form) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const focusCell = index => { cells[index].focus(); cells[index].select(); };
        const sync = () => {
          fallback.value = cells.map(cell => cell.value).join('');
          cells.forEach(cell => cell.removeAttribute('aria-invalid'));
        };
        const distribute = (value, start) => {
          const characters = Array.from(value.trim());
          if (!characters.length) return;
          const from = characters.length >= 6 ? 0 : start;
          characters.slice(0, 6 - from).forEach((character, offset) => { cells[from + offset].value = character; });
          sync();
          focusCell(Math.min(from + characters.length, 5));
        };
        cells.forEach((cell, index) => {
          cell.disabled = false;
          cell.addEventListener('focus', () => cell.select(), options);
          cell.addEventListener('paste', event => {
            const text = event.clipboardData?.getData('text');
            if (!text) return;
            event.preventDefault();
            distribute(text, index);
          }, options);
          cell.addEventListener('input', event => {
            if (event.isComposing) return;
            if (Array.from(cell.value).length > 1 || (event.data && Array.from(event.data).length > 1)) {
              distribute(event.data || cell.value, index);
              return;
            }
            sync();
            if (cell.value && index < 5) focusCell(index + 1);
          }, options);
          cell.addEventListener('compositionend', () => {
            if (Array.from(cell.value).length > 1) distribute(cell.value, index);
            else { sync(); if (cell.value && index < 5) focusCell(index + 1); }
          }, options);
          cell.addEventListener('keydown', event => {
            if (event.key === 'Backspace' && !cell.value && index > 0) {
              event.preventDefault();
              cells[index - 1].value = '';
              sync();
              focusCell(index - 1);
            } else if (event.key === 'ArrowLeft' && index > 0) {
              event.preventDefault(); focusCell(index - 1);
            } else if (event.key === 'ArrowRight' && index < 5) {
              event.preventDefault(); focusCell(index + 1);
            }
          }, options);
        });
        const initialValue = fallback.value;
        fallback.type = 'hidden';
        fallback.required = false;
        fallback.hidden = true;
        this.querySelector('.sr-code-label').htmlFor = cells[0].id;
        this.querySelector('.sr-code-cells').hidden = false;
        if (initialValue) Array.from(initialValue).slice(0, 6).forEach((character, index) => { cells[index].value = character; });
        sync();
        form.addEventListener('submit', event => {
          sync();
          const emptyIndex = cells.findIndex(cell => !cell.value);
          if (emptyIndex !== -1) { event.preventDefault(); focusCell(emptyIndex); cells[emptyIndex].reportValidity(); }
        }, options);
        form.addEventListener('reset', () => { queueMicrotask(() => { cells.forEach(cell => { cell.value = ''; }); sync(); }); }, options);
        const modal = this.closest('.password-modal-background');
        const section = this.closest('.shopify-section');
        if (!modal) return;
        let previousFocus;
        let wasOpen = false;
        const updateModal = () => {
          const open = modal.classList.contains('visible');
          modal.setAttribute('aria-hidden', String(!open));
          if (open && !wasOpen) { previousFocus = document.activeElement; focusCell(Math.max(0, cells.findIndex(cell => !cell.value))); }
          if (!open && wasOpen && previousFocus?.isConnected) previousFocus.focus();
          wasOpen = open;
        };
        this.observer = new MutationObserver(updateModal);
        this.observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
        section?.querySelectorAll('.password-store-owner, .password-store-owner-mobile').forEach(trigger => {
          trigger.setAttribute('role', 'button');
          trigger.tabIndex = 0;
          trigger.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); trigger.click(); }
          }, options);
        });
        modal.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); modal.classList.remove('visible'); }
          if (event.key !== 'Tab') return;
          const controls = [...modal.querySelectorAll('button, input:not([type="hidden"]), [tabindex="0"]')].filter(control => !control.disabled && control.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, options);
        if (this.hasAttribute('data-error')) { cells.forEach(cell => cell.setAttribute('aria-invalid', 'true')); modal.classList.add('visible'); }
        updateModal();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
